import { useTranslation as _useTranslation } from '@crehana/i18n';

import { TKeys } from './i18n';

export function useTranslation() {
  return _useTranslation<TKeys>();
}
